const UserGear3 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#708238"
      d="M9 9.855a4.25 4.25 0 1 0-4.495 0c-1.29.422-2.452 1.211-3.385 2.323a.5.5 0 1 0 .765.643C3.14 11.324 4.868 10.5 6.749 10.5s3.61.824 4.867 2.321a.5.5 0 1 0 .766-.643c-.934-1.112-2.095-1.9-3.383-2.323M3.5 6.25a3.25 3.25 0 1 1 6.499 0 3.25 3.25 0 0 1-6.5 0"
    ></path>
    <path
      fill="#708238"
      d="M15 9.393c0 .284-.106.556-.293.757a.97.97 0 0 1-.707.314h-.333v.357a.2.2 0 0 1-.05.127.16.16 0 0 1-.117.052.16.16 0 0 1-.118-.052.2.2 0 0 1-.049-.127v-.357H13a.97.97 0 0 1-.707-.314A1.1 1.1 0 0 1 12 9.393c0-.048.018-.093.049-.126a.16.16 0 0 1 .118-.053c.044 0 .086.02.117.053a.19.19 0 0 1 .05.126c0 .19.07.371.195.505s.294.21.471.21h1a.65.65 0 0 0 .471-.21.74.74 0 0 0 .196-.505c0-.19-.07-.371-.196-.505a.65.65 0 0 0-.471-.21h-.833a.97.97 0 0 1-.707-.313 1.1 1.1 0 0 1-.293-.758c0-.284.105-.557.293-.757a.97.97 0 0 1 .707-.314h.166v-.357c0-.048.018-.093.05-.127A.16.16 0 0 1 13.5 6c.044 0 .087.019.118.052a.2.2 0 0 1 .049.127v.357h.166c.265 0 .52.113.707.314.188.2.293.473.293.757a.19.19 0 0 1-.049.126.16.16 0 0 1-.117.053.16.16 0 0 1-.118-.053.2.2 0 0 1-.049-.126.74.74 0 0 0-.195-.505.65.65 0 0 0-.472-.21h-.666a.65.65 0 0 0-.472.21.74.74 0 0 0-.195.505c0 .19.07.371.195.505s.295.21.472.21H14c.265 0 .52.113.707.314.187.2.293.473.293.757"
    ></path>
  </svg>
);

export default UserGear3;

